import { useSelector } from "react-redux";
import { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import {
  HiHome,
  HiUsers,
  HiDocumentText,
  HiChatAlt2,
  HiPlus,
  HiChartBar,
  HiBell,
  HiCog,
} from "react-icons/hi";

import AdminNavbar from "./adminnavbar";
import SignInForm from "../../components/loginform";

export default function AdminLayout() {
  const user = useSelector((state) => state.user.value);
  const [sidebarOpen, setSidebarOpen] = useState(false); 
  
  return (
    <>
      {!user ? (
        <SignInForm />
      ) : (
        
        <div className="min-h-screen flex flex-col bg-white text-black">
          <AdminNavbar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />

          <div className="min-h-screen bg-gray-100 flex flex-col">
            <div className="flex flex-1">
              {/* LEFT SIDEBAR */}
              <aside
                className={`${
                  sidebarOpen ? "block" : "hidden"
                } lg:block w-64 bg-gray-800 text-white p-6 space-y-4 fixed lg:static z-20 h-full lg:h-auto top-16 left-0`}
              >
                <h2 className="text-lg font-semibold mb-4">
                  Admin Dashboard
                </h2>

                <ul className="space-y-3 text-sm">
                  <li>
                    <Link
                      to="/admin"
                      className="flex items-center gap-3 hover:text-gray-300 transition"
                    >
                      <HiHome className="text-lg" />
                      Dashboard
                    </Link>
                  </li>
                   { user.role === "systemadmin" || user.role ==='admin'
                   ?
                    <li>
                    <Link
                      to="/admin/users"
                      className="flex items-center gap-3 hover:text-gray-300 transition"
                    >
                      <HiUsers className="text-lg" />
                      Manage Users
                    </Link>
                  </li>
                   :
                   " "
                   } 
                  

                  <li>
                    {}
                    <Link
                      to="/admin/posts"
                      className="flex items-center gap-3 hover:text-gray-300 transition"
                    >
                      <HiDocumentText className="text-lg" />
                      Manage Posts
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/admin/meter-price"
                      className="flex items-center gap-3 hover:text-gray-300 transition"
                    >
                      <HiChatAlt2 className="text-lg" />
                      Map Meter Price
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/admin/jobs"
                      className="flex items-center gap-3 hover:text-gray-300 transition"
                    >
                      <HiChatAlt2 className="text-lg" />
                      Manage Jobs
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/admin/orders"
                      className="flex items-center gap-3 hover:text-gray-300 transition"
                    >
                      <HiChatAlt2 className="text-lg" />
                      MYTO Orders
                    </Link>
                  </li>
               

                  <li>
                    <Link
                      to="/admin/financial-statement"
                      className="flex items-center gap-3 hover:text-gray-300 transition"
                    >
                      <HiCog className="text-lg" />
                      Financial Statement
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/admin/feeders-reports"
                      className="flex items-center gap-3 hover:text-gray-300 transition"
                    >
                      <HiCog className="text-lg" />
                      Feeders Reports
                    </Link>
                  </li>
                </ul>
              </aside>

              {/* MAIN CONTENT */}
              <main className="flex-1 p-6 lg:ml-0">
                <Outlet />
              </main>

              {/* RIGHT SIDEBAR */}
              <aside className="hidden xl:block w-64 bg-gray-100 text-gray-900 p-6 space-y-4">
                <h2 className="text-lg font-semibold mb-4">
                  Quick Actions
                </h2>

                <ul className="space-y-3 text-sm">
                  <li>
                    <Link
                      to="/admin/post/new"
                      className="flex items-center gap-3 text-blue-600 hover:underline"
                    >
                      <HiPlus />
                      Create Post
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/admin/analytics"
                      className="flex items-center gap-3 text-blue-600 hover:underline"
                    >
                      <HiChartBar />
                      View Analytics
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/admin/notifications"
                      className="flex items-center gap-3 text-blue-600 hover:underline"
                    >
                      <HiBell />
                      Notifications
                    </Link>
                  </li>
                </ul>
              </aside>
            </div>
          </div>
        </div>
      )}
    </>
  );
}